import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LayoutComponent} from './layout.component';
import {DashboardComponent} from './core/dashboard/dashboard.component';
import {
  CacheManagementHubResolver,
  ChangelogComponent,
  getHelpRoutes,
  ProgressHubResolver,
  StylesheetComponent
} from 'common-shared';
import {AuthGuard, CurrentUserResolver, StateResolver} from 'web-shared';

const routes: Routes = [
  {path: 'login', loadChildren: () => import('./metec-login/metec-login.module').then(value => value.MetecLoginModule)},
  {
    path: '',
    canActivate: [AuthGuard],
    component: LayoutComponent,
    resolve: {connection: CacheManagementHubResolver, state: StateResolver, user: CurrentUserResolver, progress: ProgressHubResolver},
    children: [
      {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
      {path: 'dashboard', component: DashboardComponent, data: {
          search: {
            advanced: false,
            enabled: false
          }
        }},
      {
        path: 'common', loadChildren: () => import('./metec-common/metec-common.module').then(value => value.MetecCommonModule), data: {
          breadcrumb: ''
        },
      },
      {
        path: 'manufacturing', loadChildren: () => import('./manufacturing/manufacturing.module').then(value => value.EstikoManufacturingModule), data: {
          breadcrumb: ''
        },
      },
      {
        path: 'changelog', component: ChangelogComponent
      },
      {
        path: 'stylesheet', component: StylesheetComponent
      },
      ...getHelpRoutes()
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
